import { forwardRef, useEffect } from "react";
import { Typography } from "@mui/material";
import { TextField } from "@mui/material";
import { Button, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "@mui/material";

const OrganizationNameQuestion = forwardRef(
  (
    {
      data,
      currentQuestion,
      scrollToQuestion,
      latestQuestion,
      profileNames,
      handlePayload,
      handleDisabled,
      value,
      latestStepQuestion,
      isEdit,
    },
    ref
  ) => {
    const nextQuestionHandler = (height, option) => {
      handlePayload(data, value);
      scrollToQuestion(data, height, value);
    };
    const isMobile = useMediaQuery("(max-width:900px)");

    const handleValue = (value) => {
      handlePayload(data, value);
    };

    const reg = new RegExp("^([a-zA-Z0-9-]){0,1000}$");

    const profiles = profileNames?.map((name) => name.toUpperCase());

    useEffect(() => {
      handleDisabled(
        profiles.includes(value.toUpperCase()) || !reg.test(value)
      );
    }, [value]);

    const { t } = useTranslation();
    return (
      <div
        style={{
          padding: !isMobile && "0px 10px",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
        ref={ref}
      >
        <>
          <Typography variant="subtitle1" sx={{ fontSize: "20px" }}>
            {t(data.question)}
          </Typography>
          <Grid container>
            <TextField
              id="outlined-basic"
              placeholder={t("display_name_A")}
              variant="outlined"
              fullWidth
              onChange={(e) => handleValue(e.target.value)}
              // error={checkName}
              error={
                profiles.includes(value.toUpperCase()) ||
                !reg.test(value.toUpperCase())
              }
              helperText={
                !isEdit && profiles.includes(value.toUpperCase())
                  ? t("used_name")
                  : " " && !reg.test(value)
                  ? t("only_alphanumeric")
                  : ""
              }
              value={value}
              disabled={isEdit}
            />
          </Grid>

          {currentQuestion === data.id &&
          currentQuestion !== latestQuestion &&
          !(isEdit && latestStepQuestion === data.id) ? (
            <>
              {" "}
              <Button
                onClick={(option) => {
                  nextQuestionHandler(ref.current.clientHeight, option);
                }}
                disabled={
                  (data.required && !value) ||
                  profiles.includes(value.toUpperCase()) ||
                  !reg.test(value)
                }
                style={{ height: "50px", marginTop: "20px" }}
                color="secondary"
                variant="contained"
                fullWidth
              >
                {t("next")}
              </Button>
            </>
          ) : (
            <></>
          )}
        </>
      </div>
    );
  }
);

export default OrganizationNameQuestion;
